import React from "react";
import CartProgressSkeleton from "./CartProgressSkeleton";
import CartTableDataSkeleton from "./CartTableDataSkeleton";

const CartSkeleton: React.FC = () => {
  return (
    <>
      <section className="section relative text-white py-10 max-md:py-6 max-md:px-4 blue-bg-dots">
        <div className="container mx-auto max-sm:p-0">
          <h2 className="text-[#91DBE7] text-6xl max-md:text-4xl text-start mb-8 max-sm:mb-5">
            ca<span className="text-primary">rt</span>
          </h2>

          <CartProgressSkeleton />

          <CartTableDataSkeleton />
        </div>
      </section>
    </>
  );
};

export default CartSkeleton;
